__turbopack_context__.v({
  "className": "tagada_62d40ad9-module__F3PLya__className",
  "variable": "tagada_62d40ad9-module__F3PLya__variable",
});
